import * as types from "../../constants/index"
import { mediaSDK } from "../../utils/getSDK"
import storage from "@/utils/operateStorage"

let selectedAudioOutputDevice = storage.get("AUDIO_OUTPUT_DEVICE") || 0

export default {
  state: {
    cameraStatus: false, // 摄像头是否打开
    deviceList: {
      data: "",
      status: ""
    },
    selectedDevice: {
      video: 0,
      audio: 0
    },
    selectedAudioOutputDevice,
    lostRate: 0,
    startGetLostRate: false,
    mediaDisabled:false // 点击设置后再打开视频
  },
  actions: {
    async fetchDeviceList({ dispatch, commit }) {
      try {
        commit(types.FETCH_DEVICE_LIST)
        commit(
          types.FETCH_DEVICE_LIST_SUCCESSED,
          await mediaSDK.getDeviceList()
        )
      } catch (error) {
        return Promise.reject(error)
      }
    },
    changeDevice({ commit }, payload) {
      commit(types.CHANGE_DEVICE, payload)
    },
    modifyLostRate({ commit }, payload = 0) {
      commit(types.VIDEO_LOST_RATE, payload)
    }
  },
  mutations: {
    MEDIA_CAMERA_STATUS(state, payload) {
      state.cameraStatus = payload
    },
    FETCH_DEVICE_LIST(state, payload) {
      state.deviceList = Object.assign({}, state.deviceList, {
        data: "",
        status: types.FETCH
      })
    },
    FETCH_DEVICE_LIST_SUCCESSED(state, payload) {
      state.deviceList = Object.assign({}, state.deviceList, {
        data: JSON.stringify(payload),
        status: types.FETCH_SUCCESSED
      })
    },
    MEDIA_LOCALSTREAM(state, payload) {
      state.localstream = payload
    },
    [types.CHANGE_DEVICE](state, payload = {}) {
      let { video, audio } = payload
      if (video !== undefined) {
        state.selectedDevice.video = video
      }
      if (audio !== undefined) {
        state.selectedDevice.audio = audio
      }
    },
    [types.CHANGE_AUDIO_OUTPUT_DEVICE](state, payload) {
      state.selectedAudioOutputDevice = payload
    },
    [types.VIDEO_LOST_RATE](state, payload) {
      state.lostRate = payload
    },
    [types.START_GET_LOST_RATE](state) {
      state.startGetLostRate = true
    },
    [types.MEDIA_DISABLED](state, payload) {
      state.mediaDisabled = payload
    }
  },
  getters: {
    cameraStatus: state => state.cameraStatus,
    deviceList: state => state.deviceList,
    deviceLists: state => {
      if (!state.deviceList.data.length) {
        return []
      } else {
        let lists = JSON.parse(state.deviceList.data)
        let videoList = []
        let audioList = []
        let audioOutputList = []
        lists.forEach(list => {
          if (list.kind === "videoinput") {
            videoList.push(list)
          } else if (list.kind === "audioinput") {
            audioList.push(list)
          } else if (list.kind === "audiooutput") {
            audioOutputList.push(list)
          }
        })
        return { videoList, audioList, audioOutputList }
      }
    },
    mediaDisabled: state => state.mediaDisabled,
  }
}
